export const ONBOARDING_VIEWPORT_BREAKPOINTS = {
  compactHeight: 680,
  compactWidth: 340,
  condensedHeight: 820,
  condensedWidth: 560,
  desktopWidth: 768,
} as const;

export function getOnboardingViewport(width: number, height: number) {
  const compact =
    height < ONBOARDING_VIEWPORT_BREAKPOINTS.compactHeight ||
    width <= ONBOARDING_VIEWPORT_BREAKPOINTS.compactWidth;
  const condensed =
    compact ||
    (height < ONBOARDING_VIEWPORT_BREAKPOINTS.condensedHeight &&
      width < ONBOARDING_VIEWPORT_BREAKPOINTS.condensedWidth);

  return {
    compact,
    condensed,
    desktop: width >= ONBOARDING_VIEWPORT_BREAKPOINTS.desktopWidth,
    mobile: width < ONBOARDING_VIEWPORT_BREAKPOINTS.condensedWidth,
  };
}
